var MiniCart = {
	init:function(){
		Debug.log("MINI CART INIT");
		$(".header .woocommerce-cart").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			MiniCart.open_cart();
		});
		$(".mini-cart-container .close").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			
			MiniCart.close_cart();
		});
		$(".mini-cart-container .shadow").on("click touchend", function(e){
			Debug.log("CLICK SHADOW");
			if(e.type == "touchend"){
				$(this).off("click");
			}
			
			MiniCart.close_cart();
		})
		
		$("body").on("wc_fragments_loaded", function(){
			MiniCart.open_cart();
			
		})
	},
	open_cart:function(){
		$(".mini-cart-container").addClass("open");
	},
	close_cart:function(){
		$(".mini-cart-container").removeClass("open");
	}
}

$(window).load(function(){
	
	Debug.log("WINDOW LOAD : " + $(".mini-cart-container").length);
	
	if($(".mini-cart-container").length){
		MiniCart.init();
		
	}
})